import React from "react";
import {
  FaShieldAlt,
  FaMapMarkerAlt,
  FaBell,
  FaCamera,
  FaUserLock,
  FaGlobe,
  FaEnvelope,
  FaTrashAlt,
  FaCookieBite,
} from "react-icons/fa";

const Section = ({ icon, title, children }) => (
  <div className="bg-white rounded-2xl shadow-md p-6 mb-6 border border-gray-100">
    <div className="flex items-center gap-3 mb-4">
      <div className="bg-orange-100 p-3 rounded-full text-orange-500 text-xl">
        {icon}
      </div>
      <h2 className="text-2xl font-bold text-gray-800">{title}</h2>
    </div>
    <div className="text-gray-600 leading-8">{children}</div>
  </div>
);

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gray-100 py-16 px-5">
      <div className="max-w-5xl mx-auto">

        {/* Header */}

        <div className="bg-gradient-to-r from-orange-500 to-orange-600 rounded-3xl shadow-xl text-white p-10 mb-10 text-center">

          <h1 className="text-5xl font-bold mb-3">
            🛡 Privacy Policy
          </h1>

          <p className="text-xl opacity-90">
            Hooks Delivery Partner
          </p>

          <p className="mt-4 text-orange-100">
            Last Updated: July 31, 2026
          </p>

        </div>

        <Section
          icon={<FaShieldAlt />}
          title="Information We Collect"
        >
          <ul className="list-disc ml-6 space-y-2">
            <li>Name and profile information</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Courier account details</li>
            <li>Device information</li>
            <li>Location information during deliveries</li>
          </ul>
        </Section>

        <Section
          icon={<FaMapMarkerAlt />}
          title="Location Data"
        >
          We collect your location while you are delivering orders.
          This allows customers to track deliveries and helps our
          dispatch system assign nearby delivery requests.
        </Section>

        <Section
          icon={<FaBell />}
          title="Notifications"
        >
          We send push notifications for:

          <ul className="list-disc ml-6 mt-3 space-y-2">
            <li>New delivery requests</li>
            <li>Order updates</li>
            <li>Important account notifications</li>
          </ul>
        </Section>

        <Section
          icon={<FaCamera />}
          title="Camera & Images"
        >
          If you upload profile pictures or delivery proof photos,
          those images are securely stored and used only for
          operating the delivery platform.
        </Section>

        <Section
          icon={<FaUserLock />}
          title="How We Protect Your Data"
        >
          We use secure servers, encrypted communication, protected
          authentication and access controls to safeguard your
          information from unauthorized access.
        </Section>

        <Section
          icon={<FaGlobe />}
          title="Third-Party Services"
        >
          Hooks Delivery Partner may use trusted third-party services
          including:

          <ul className="list-disc ml-6 mt-3 space-y-2">
            <li>Google Maps</li>
            <li>Firebase Cloud Messaging</li>
            <li>Expo Services</li>
            <li>Cloud Hosting Services</li>
          </ul>

          These providers process information according to their own
          privacy policies.
        </Section>

        <Section
          icon={<FaCookieBite />}
          title="Cookies (Website)"
        >
          Our website may use cookies and similar technologies to
          improve user experience, remember preferences and analyse
          website traffic.
        </Section>

        <Section
          icon={<FaTrashAlt />}
          title="Your Rights"
        >
          You may request to:

          <ul className="list-disc ml-6 mt-3 space-y-2">
            <li>Access your personal information</li>
            <li>Correct inaccurate information</li>
            <li>Delete your account</li>
            <li>Request data removal</li>
          </ul>
        </Section>

        <Section
          icon={<FaEnvelope />}
          title="Contact Us"
        >
          If you have any questions about this Privacy Policy,
          please contact us.

          <div className="mt-5 bg-orange-50 rounded-xl p-5">

            <p>
              <strong>Company:</strong> Hooks Food
            </p>

            <p>
              <strong>Email:</strong> support@getcoredispatch.cloud
            </p>

            <p>
              <strong>Website:</strong><br />

              https://getcoredispatch.cloud
            </p>

          </div>

        </Section>

        <div className="text-center mt-12 text-gray-500 text-sm">
          © 2026 Hooks Delivery Partner. All Rights Reserved.
        </div>

      </div>
    </div>
  );
}